<div [@textBoxAnimation] *ngIf="report">

  <div  id="wrap" >
    <div id="closeBtn">
      <span (click)="close();">×</span>
    </div>


    <div id="head_wrap" class="fontSize18">
      关键行动分析
    </div>

    <!--<img src="{{assetsRoute}}/picture/casepracticeteam/Alex.png" [@tourReviewAnimation]="tourReviewShow ? 'showTourReview' : 'hideTourReview'" alt="" id="alex">-->
    <div id="subWrapOne">
      <div id="textBox"  class="fontSize14">
        恭喜你完成了此次情景模拟，虽然我们把场景设置在了未来，但相似的情景其实在你身边也时常发生着。<br/><br/>
        比如说客舱调整，就如同在我们的实际工作中存在着的各种流程和职责划分不清的问题。有时候你的团队成员可能也像案例中的小伙伴们一样觉得团队做的事很Low，看不到工作的意义和价值；也许会像季宁一样做事没有重点；或者有时候，成员之间说话火药味十足，导致大家各自为战，极少配合；或是互相戒备，不怎么交流。<br/><br/>
        在面对这些问题时，你带领大<br/>家解决得如何呢？最佳的应对<br/>方法又该是什么样的呢？点击<br/>“具体分析”，听我一一道来。
      </div>

      <div id="nextBtn" class="fontSize16" (click)="subWrapOneOut()">
        具体分析
        <img src="{{assetsRoute}}/picture/courselearning/arrow-right.png" alt="" id="arrow_right_1">
        <img src="{{assetsRoute}}/picture/courselearning/arrow-right.png" alt="" id="arrow_right_2">
      </div>
    </div>

    <div id="subWrapTwo" [@subWrapTwoAnimation]="subWrapTwoShow ? 'showSubWrapTwo': 'hideSubWrapTwo'">
      <div id="clickTip" class="fontSize14">
        点击下面关键行动，查看分析详情
      </div>
      <img src="{{assetsRoute}}/picture/casepracticeteam/comment.png" alt="" id="tourReview" class="imgAble" (click)="tourReviewBoxIn()">

      <div class="keyActionItem keyActionItemOne" (click)="analysisBoxIn('ka1')">
        <img src="{{assetsRoute}}/picture/casepracticeteam/p1.png" alt="" class="keyActionItemCircle">
        <div class="keyActionItemText fontSize16">
          {{report.ka1.name}}
        </div>
        <img src="{{assetsRoute}}/picture/casepracticeteam/Star.png" alt="" class="star star1" *ngIf="report.ka1.total>=1">
        <img src="{{assetsRoute}}/picture/casepracticeteam/Star.png" alt="" class="star star2" *ngIf="report.ka1.total>=2">
        <img src="{{assetsRoute}}/picture/casepracticeteam/Star.png" alt="" class="star star3" *ngIf="report.ka1.total>=3">
        <img src="{{assetsRoute}}/picture/casepracticeteam/Star.png" alt="" class="star star4" *ngIf="report.ka1.total>=4">
        <img src="{{assetsRoute}}/picture/casepracticeteam/Star.png" alt="" class="star star5" *ngIf="report.ka1.total>=5">

        <img src="{{assetsRoute}}/picture/casepracticeteam/star_gray.png" alt="" class="star star1" *ngIf="report.ka1.total<1">
        <img src="{{assetsRoute}}/picture/casepracticeteam/star_gray.png" alt="" class="star star2" *ngIf="report.ka1.total<2">
        <img src="{{assetsRoute}}/picture/casepracticeteam/star_gray.png" alt="" class="star star3" *ngIf="report.ka1.total<3">
        <img src="{{assetsRoute}}/picture/casepracticeteam/star_gray.png" alt="" class="star star4" *ngIf="report.ka1.total<4">
        <img src="{{assetsRoute}}/picture/casepracticeteam/star_gray.png" alt="" class="star star5" *ngIf="report.ka1.total<5">
      </div>

      <div class="keyActionItem keyActionItemTwo" (click)="analysisBoxIn('ka2')">
        <img src="{{assetsRoute}}/picture/casepracticeteam/p2.png" alt="" class="keyActionItemCircle">
        <div class="keyActionItemText fontSize16">
          {{report.ka2.name}}
        </div>
        <img src="{{assetsRoute}}/picture/casepracticeteam/Star.png" alt="" class="star star1" *ngIf="report.ka2.total>=1">
        <img src="{{assetsRoute}}/picture/casepracticeteam/Star.png" alt="" class="star star2" *ngIf="report.ka2.total>=2">
        <img src="{{assetsRoute}}/picture/casepracticeteam/Star.png" alt="" class="star star3" *ngIf="report.ka2.total>=3">
        <img src="{{assetsRoute}}/picture/casepracticeteam/Star.png" alt="" class="star star4" *ngIf="report.ka2.total>=4">
        <img src="{{assetsRoute}}/picture/casepracticeteam/Star.png" alt="" class="star star5" *ngIf="report.ka2.total>=5">

        <img src="{{assetsRoute}}/picture/casepracticeteam/star_gray.png" alt="" class="star star1" *ngIf="report.ka2.total<1">
        <img src="{{assetsRoute}}/picture/casepracticeteam/star_gray.png" alt="" class="star star2" *ngIf="report.ka2.total<2">
        <img src="{{assetsRoute}}/picture/casepracticeteam/star_gray.png" alt="" class="star star3" *ngIf="report.ka2.total<3">
        <img src="{{assetsRoute}}/picture/casepracticeteam/star_gray.png" alt="" class="star star4" *ngIf="report.ka2.total<4">
        <img src="{{assetsRoute}}/picture/casepracticeteam/star_gray.png" alt="" class="star star5" *ngIf="report.ka2.total<5">
      </div>

      <div class="keyActionItem keyActionItemOne" (click)="analysisBoxIn('ka3')">
        <img src="{{assetsRoute}}/picture/casepracticeteam/p3.png" alt="" class="keyActionItemCircle">
        <div class="keyActionItemText fontSize16">
          {{report.ka3.name}}
        </div>
        <img src="{{assetsRoute}}/picture/casepracticeteam/Star.png" alt="" class="star star1" *ngIf="report.ka3.total>=1">
        <img src="{{assetsRoute}}/picture/casepracticeteam/Star.png" alt="" class="star star2" *ngIf="report.ka3.total>=2">
        <img src="{{assetsRoute}}/picture/casepracticeteam/Star.png" alt="" class="star star3" *ngIf="report.ka3.total>=3">
        <img src="{{assetsRoute}}/picture/casepracticeteam/Star.png" alt="" class="star star4" *ngIf="report.ka3.total>=4">
        <img src="{{assetsRoute}}/picture/casepracticeteam/Star.png" alt="" class="star star5" *ngIf="report.ka3.total>=5">

        <img src="{{assetsRoute}}/picture/casepracticeteam/star_gray.png" alt="" class="star star1" *ngIf="report.ka3.total<1">
        <img src="{{assetsRoute}}/picture/casepracticeteam/star_gray.png" alt="" class="star star2" *ngIf="report.ka3.total<2">
        <img src="{{assetsRoute}}/picture/casepracticeteam/star_gray.png" alt="" class="star star3" *ngIf="report.ka3.total<3">
        <img src="{{assetsRoute}}/picture/casepracticeteam/star_gray.png" alt="" class="star star4" *ngIf="report.ka3.total<4">
        <img src="{{assetsRoute}}/picture/casepracticeteam/star_gray.png" alt="" class="star star5" *ngIf="report.ka3.total<5">
      </div>

      <div class="keyActionItem keyActionItemTwo" (click)="analysisBoxIn('ka4')">
        <img src="{{assetsRoute}}/picture/casepracticeteam/p4.png" alt="" class="keyActionItemCircle">
        <div class="keyActionItemText fontSize16">
          {{report.ka4.name}}
        </div>
        <img src="{{assetsRoute}}/picture/casepracticeteam/Star.png" alt="" class="star star1" *ngIf="report.ka4.total>=1">
        <img src="{{assetsRoute}}/picture/casepracticeteam/Star.png" alt="" class="star star2" *ngIf="report.ka4.total>=2">
        <img src="{{assetsRoute}}/picture/casepracticeteam/Star.png" alt="" class="star star3" *ngIf="report.ka4.total>=3">
        <img src="{{assetsRoute}}/picture/casepracticeteam/Star.png" alt="" class="star star4" *ngIf="report.ka4.total>=4">
        <img src="{{assetsRoute}}/picture/casepracticeteam/Star.png" alt="" class="star star5" *ngIf="report.ka4.total>=5">

        <img src="{{assetsRoute}}/picture/casepracticeteam/star_gray.png" alt="" class="star star1" *ngIf="report.ka4.total<1">
        <img src="{{assetsRoute}}/picture/casepracticeteam/star_gray.png" alt="" class="star star2" *ngIf="report.ka4.total<2">
        <img src="{{assetsRoute}}/picture/casepracticeteam/star_gray.png" alt="" class="star star3" *ngIf="report.ka4.total<3">
        <img src="{{assetsRoute}}/picture/casepracticeteam/star_gray.png" alt="" class="star star4" *ngIf="report.ka4.total<4">
        <img src="{{assetsRoute}}/picture/casepracticeteam/star_gray.png" alt="" class="star star5" *ngIf="report.ka4.total<5">
      </div>

      <div class="keyActionItem keyActionItemOne" (click)="analysisBoxIn('ka5')">
        <img src="{{assetsRoute}}/picture/casepracticeteam/p5.png" alt="" class="keyActionItemCircle">
        <div class="keyActionItemText fontSize16">
          {{report.ka5.name}}
        </div>
        <img src="{{assetsRoute}}/picture/casepracticeteam/Star.png" alt="" class="star star1" *ngIf="report.ka5.total>=1">
        <img src="{{assetsRoute}}/picture/casepracticeteam/Star.png" alt="" class="star star2" *ngIf="report.ka5.total>=2">
        <img src="{{assetsRoute}}/picture/casepracticeteam/Star.png" alt="" class="star star3" *ngIf="report.ka5.total>=3">
        <img src="{{assetsRoute}}/picture/casepracticeteam/Star.png" alt="" class="star star4" *ngIf="report.ka5.total>=4">
        <img src="{{assetsRoute}}/picture/casepracticeteam/Star.png" alt="" class="star star5" *ngIf="report.ka5.total>=5">

        <img src="{{assetsRoute}}/picture/casepracticeteam/star_gray.png" alt="" class="star star1" *ngIf="report.ka5.total<1">
        <img src="{{assetsRoute}}/picture/casepracticeteam/star_gray.png" alt="" class="star star2" *ngIf="report.ka5.total<2">
        <img src="{{assetsRoute}}/picture/casepracticeteam/star_gray.png" alt="" class="star star3" *ngIf="report.ka5.total<3">
        <img src="{{assetsRoute}}/picture/casepracticeteam/star_gray.png" alt="" class="star star4" *ngIf="report.ka5.total<4">
        <img src="{{assetsRoute}}/picture/casepracticeteam/star_gray.png" alt="" class="star star5" *ngIf="report.ka5.total<5">
      </div>

      <div class="keyActionItem keyActionItemTwo" (click)="analysisBoxIn('ka6')">
        <img src="{{assetsRoute}}/picture/casepracticeteam/p6.png" alt="" class="keyActionItemCircle">
        <div class="keyActionItemText fontSize16">
          {{report.ka6.name}}
        </div>
        <img src="{{assetsRoute}}/picture/casepracticeteam/Star.png" alt="" class="star star1" *ngIf="report.ka6.total>=1">
        <img src="{{assetsRoute}}/picture/casepracticeteam/Star.png" alt="" class="star star2" *ngIf="report.ka6.total>=2">
        <img src="{{assetsRoute}}/picture/casepracticeteam/Star.png" alt="" class="star star3" *ngIf="report.ka6.total>=3">
        <img src="{{assetsRoute}}/picture/casepracticeteam/Star.png" alt="" class="star star4" *ngIf="report.ka6.total>=4">
        <img src="{{assetsRoute}}/picture/casepracticeteam/Star.png" alt="" class="star star5" *ngIf="report.ka6.total>=5">

        <img src="{{assetsRoute}}/picture/casepracticeteam/star_gray.png" alt="" class="star star1" *ngIf="report.ka6.total<1">
        <img src="{{assetsRoute}}/picture/casepracticeteam/star_gray.png" alt="" class="star star2" *ngIf="report.ka6.total<2">
        <img src="{{assetsRoute}}/picture/casepracticeteam/star_gray.png" alt="" class="star star3" *ngIf="report.ka6.total<3">
        <img src="{{assetsRoute}}/picture/casepracticeteam/star_gray.png" alt="" class="star star4" *ngIf="report.ka6.total<4">
        <img src="{{assetsRoute}}/picture/casepracticeteam/star_gray.png" alt="" class="star star5" *ngIf="report.ka6.total<5">
      </div>

      <!-- <div id="transitionalText" class="fontSize18 lineHeight24">
          {{chuanjie}}
      </div>

      <div id="linkToPostSurvey" class="fontSize18" *ngIf="learningTour.tour_meta_id == 1" (click)="linkToPostSurvey()">
          进入能力考核
      </div> -->

      <div id="space">

      </div>

    </div>

    <div id="tourReviewBox" [@tourReviewBoxAnimation]="tourReviewBoxShow ? 'showTourReviewBox':'hideTourReviewBox'" class="fontSize16 lineHeight24">
      恭喜你完成了此次情景模拟，虽然我们把场景设置在了未来，但相似的情景其实在你身边也时常发生着。<br/><br/>
      比如说客舱调整，就如同在我们的实际工作中存在着的各种流程和职责划分不清的问题。有时候你的团队成员可能也像案例中的小伙伴们一样觉得团队做的事很Low，看不到工作的意义和价值；也许会像季宁一样做事没有重点；或者有时候，成员之间说话火药味十足，导致大家各自为战，极少配合；或是互相戒备，不怎么交流。<br/><br/>
      在面对这些问题时，你带领大家解决得如何呢？最佳的应对方法又该是什么样的呢？点击“具体分析”，听我一一道来。
    </div>

    <div id="closeBtn1" (click)="tourReviewBoxOut()"></div>

    <div id="bestPathBox" [@bestPathBoxAnimation]="bestPathBoxShow ? 'showBestPathBox': 'hideBestPathBox'" class="fontSize16 lineHeight24">
      <p class="excellentDemonstrationTitle flowerBorderBottom"><br/>优秀示范</p>
      <p class="sectionTitle">流程因素</p>
      <div class="sectionBox sectionBox1">
        <div class="sectionIcon">剧情1</div>
        <p><span>季宁</span><span>立娜，23号舱的旅客怎么一下多了两个？我之前就已经安排了6个人啊。</span></p>
        <p><span>王立娜</span><span>哦，因为我这里餐饮配送需要，所以把16号舱的两位旅客调了过来。</span></p>
        <p><span>季宁</span><span>可这个是我负责的，怎么不和我说一声就调整了啊！</span></p>
        <p><span>王立娜</span><span>又没什么关系，你再改一下就好啦。</span></p>
        <p><span>方科科</span><span>王立娜，你这不对啊，客舱安排是季宁的职责，你要调整至少也要先问问她。</span></p>
        <p><span>王立娜</span><span>你跳出来干嘛啊？和你有什么关系？</span></p>
        <p><span>秦飞</span><span>大家伙先消消气，呀，这不是老大么？</span></p>
        <p><span>旁白</span><span>刚进会议室，就见到大家在争论，你会怎么做呢？</span></p>
        <p class="fontBlue">「最佳选择」</p>
        <p>唉？我还是先问问到底是什么情况吧。</p>
        <div class="bg-lightBlue"><p class="excellentDemonstrationTitle"> 点 评</p>
          <p>当下属发生争执时，一定要先问情况，让当事人先发表自己的观点，避免根据过往的印象和经验来主观臆断。</p></div>
      </div>
      <div class="sectionSlide"  data-target="sectionBox1" #sectionSlide (click)="slideBestPathBox(sectionSlide)">
        <div class="sectionIcon">剧情1</div>
        <p class="sectionSlideTriangle rotate180"></p>
        <p class="sectionSlideTxt">收起</p></div>


      <div class="sectionBox sectionBox2 hidden">
        <div class="sectionIcon">剧情2</div>
        <p><span class="fontBlue">我</span><span>怎么啦，发生了什么事？</span></p>
        <p><span>季宁</span><span>立娜把两个16号舱的旅客调到了23号舱，也没和我说，这个之前一直都是我负责的。</span></p>
        <p><span>王立娜</span><span>之前的餐饮配送安排不合理，所以调整是必须的，我没觉得这样的调整有什么不合理！</span></p>
        <p><span>方科科</span><span>这有什么好争的？又不重要，我觉得咱们团队做的事都没啥价值啊。</span></p>
        <p><span>秦飞</span><span>科科，你这话说得就不对了，我觉得这事挺重要的啊。</span></p>
        <p class="fontBlue">「最佳选择」</p>
        <p>方科科和秦飞的心里到底是怎么想的呢？我还是问问他们。</p>
        <div class="bg-lightBlue"><p class="excellentDemonstrationTitle"> 点 评</p>
          <p>通过询问，让每个人都参与发表意见，可以为你的决策收集更多的信息。</p></div>
      </div>
      <div class="sectionSlide"  data-target="sectionBox2" #sectionSlide2 (click)="slideBestPathBox(sectionSlide2)">
      <div class="sectionIcon opacity100">剧情2</div>
        <p class="sectionSlideTriangle"></p>
        <p class="sectionSlideTxt">展开</p></div>


      <div class="sectionBox sectionBox3 hidden">
        <div class="sectionIcon">剧情3</div>
        <p><span class="fontBlue">我</span><span>秦飞，方科科你俩对这事是怎么看的呢？</span></p>
        <p><span>方科科</span><span>我觉得就是立娜的问题，客舱安排是季宁的事，她擅自换人还有理了不成？不过老实说，我还是觉得这事没什么大不了的。</span></p>
        <p><span>秦飞</span><span>科科，你说话别那么重，立娜也是为了工作。</span></p>
        <p><span>王立娜</span><span>我觉得是我沟通上出了问题吧，下次客舱临时有调整，我及时通知季宁好了。</span></p>
        <p><span>季宁</span><span>立娜，我觉得还是明确下我们之间的职责吧，客舱调配应该由我来统一安排，你有需求可以先和我提出来。</span></p>
        <p><span>秦飞</span><span>老大，看来大家的看法不统一，你看怎么办呢？</span></p>
        <p class="fontBlue">「最佳选择」</p>
        <p>已经充分征求了大家的意见，基本可以断定是职责分工出了问题。</p>
        <div class="bg-lightBlue"><p class="excellentDemonstrationTitle"> 点 评</p>
          <p>此时出现了分歧，季宁和方科科都觉得是王立娜有职责不清的情况，而王立娜却认为是自己沟通不及时。根据前面收集到的信息，可以知道客舱调配是季宁的职责，所以可以断定是职责出了问题，而不是王立娜自认为的沟通不及时。</p>
        </div>
      </div>
      <div class="sectionSlide"  data-target="sectionBox3" #sectionSlide3 (click)="slideBestPathBox(sectionSlide3)">
      <div class="sectionIcon opacity100">剧情3</div>
        <p class="sectionSlideTriangle"></p>
        <p class="sectionSlideTxt">展开</p></div>


      <div class="sectionBox sectionBox4 hidden">
        <div class="sectionIcon">剧情4</div>
        <p><span class="fontBlue">我</span><span>季宁和科科说得有道理，我们在职责上有很多不清晰的地方，所以我想借这次机会和大家制定一下我们团队的章程。</span></p>
        <p><span>秦飞</span><span>（内心OS）这个我听说过，看来老大还是有两把刷子的。</span></p>
        <p><span>方科科</span><span>哦？这个是什么，老大给我们介绍介绍。不过我们有必要在这事上面花那么多时间么？</span></p>
        <p><span>旁白</span><span>一个小时过去了…大家重新明确了各自的职责。接下来，针对“流程”这个要素你觉得还有什么需要和小伙伴们确认呢？</span></p>
        <p class="fontBlue">「最佳选择」</p>
        <p>刚才科科有说这事不重要，也听过有人说我们做的事很Low，先和大家明确下团队使命吧。</p>
        <div class="bg-lightBlue"><p class="excellentDemonstrationTitle"> 点 评</p>
          <p>
            根据前面的对话，方科科一直在说觉得这事不重要，觉得团队做的事没有价值。结合前情提要中的“小伙伴们觉得团队做的事很Low”这个现象，可以发现这是个没有什么使命感的团队，如果一个团队连使命感都没有，那就谈不上先去解决其他问题了。</p>
        </div>
      </div>
      <div class="sectionSlide"  data-target="sectionBox4" #sectionSlide4 (click)="slideBestPathBox(sectionSlide4)">
      <div class="sectionIcon opacity100">剧情4</div>
        <p class="sectionSlideTriangle"></p>
        <p class="sectionSlideTxt">展开</p></div>


      <div class="sectionBox  sectionBox5 hidden">
        <div class="sectionIcon">剧情5</div>
        <p><span class="fontBlue">我</span><span>之前我听到有人说觉得我们团队做的事有些Low，今天正好和大家也讨论下我们团队的使命是什么？</span></p>
        <p><span>王立娜</span><span>我觉得就是满足旅客的需要啊，安全送到就好啦。</span></p>
        <p><span>方科科</span><span>我们做的事的确挺低端的，这能算什么使命啊…</span></p>
        <p><span>秦飞</span><span>我们团队就是要让旅客安全到达火星，支持移民计划呀。</span></p>
        <p><span class="fontBlue">我</span><span>看来大家对团队的使命都各有不同的看法啊，我们来讨论一下吧，然后写进我们的“团队章程”。</span></p>
        <p><span>旁白</span><span>经过一小时的讨论，最终确定了团队的使命。</span></p>
        <p><span>季宁</span><span>原来我们的团队这么重要，我以后得更加努力！</span></p>
        <p><span>方科科</span><span>看来火星移民计划真的离不开每个团队的努力，哪怕只是做一些基础的工作。</span></p>
        <p><span class="fontBlue">我</span><span>好了，大家都清楚了我们的使命，那接下来还需要和大家确认：</span></p>
        <p class="fontBlue">「最佳选择」</p>
        <p>三个月后，让客户的满意率达到95%以上。</p>
        <div class="bg-lightBlue"><p class="excellentDemonstrationTitle"> 点 评</p>
          <p>目标要够SMART，才能让团队成员清楚地知道接下来我们要去哪。</p></div>
      </div>
      <div class="sectionSlide"  data-target="sectionBox5" #sectionSlide5 (click)="slideBestPathBox(sectionSlide5)">
      <div class="sectionIcon opacity100">剧情5</div>
        <p class="sectionSlideTriangle"></p>
        <p class="sectionSlideTxt">展开</p></div>

      <div class="sectionBox sectionBox6 hidden">
        <div class="sectionIcon">结局</div>
        <p><span class="fontBlue">我</span><span>在3个月航程结束后，我们要让客户对我们服务的满意率达到95%以上，大家没问题吧？</span></p>
        <p><span>秦飞</span><span>这个可以有，我觉得没问题。</span></p>
        <p><span>方科科</span><span>嗯...很好，这个目标很SMART。</span></p>
        <p><span>王立娜</span><span>之前满意率就有80%，这个挺合理的。</span></p>
        <p><span>季宁</span><span>嗯，3个月后应该没问题。</span></p>
        <p><span class="fontBlue">我</span><span>好的，这次会议就到这，请大家回去后经常查看“团队章程”，明确我们的使命、目标和各自的职责，散会！</span></p>
      </div>
      <div class="sectionSlide"  data-target="sectionBox6" #sectionSlide6 (click)="slideBestPathBox(sectionSlide6)">
      <div class="sectionIcon opacity100">结局</div>
        <p class="sectionSlideTriangle"></p>
        <p class="sectionSlideTxt">展开</p></div>

      <p class="sectionTitle">承诺因素</p>
      <div class="sectionBox sectionBox7 hidden">
        <div class="sectionIcon">剧情1</div>
        <p><span class="fontBlue">我</span><span>今天召集大家来，是我发现了一个现象，就是大家都在专注做自己的事，很少会去帮助他人，更别说互相合作去做事了。</span></p>
        <p><span>方科科</span><span>合作？有必要吗？我一个人就能把事情搞定啊！</span></p>
        <p><span>王立娜</span><span>我自己都忙不过来，哪有时间帮别人啊。</span></p>
        <p><span>季宁</span><span>【内心OS：如果我现在说需要帮忙，会很没面子吧……】</span></p>
        <p><span>旁白</span><span>出师不利，周明需要你的帮助！</span></p>
        <p class="fontBlue">「最佳选择」</p>
        <p>好吧，我先问下大家，让他们思考下自己想从团队合作中得到什么？</p>
        <div class="bg-lightBlue"><p class="excellentDemonstrationTitle"> 点 评</p>
          <p>比起直接说出观点，邀请大家一起思考，发表自己的想法，会让下属对于后面的结论和行动计划有更高的承诺度。</p></div>
      </div>
      <div class="sectionSlide"  data-target="sectionBox7" #sectionSlide7 (click)="slideBestPathBox(sectionSlide7)">
      <div class="sectionIcon opacity100">剧情1</div>
      <p class="sectionSlideTriangle"></p>
      <p class="sectionSlideTxt">展开</p></div>

    <div class="sectionBox  sectionBox8 hidden">
      <div class="sectionIcon">剧情2</div>
      <p><span class="fontBlue">我</span><span>这样，我先问每人一个问题：你期望从团队中得到什么？请写在一张纸上，然后贴出来给大家看看。</span></p>
      <p><span>王立娜</span><span>为什么要写这个啊？</span></p>
      <p><span>方科科</span><span>【内心OS：老大你这个套路有点深了啊…】</span></p>
      <p><span>季宁</span><span>【内心OS：这个我说出来会被大家笑话吧…】</span></p>
      <p><span>秦飞</span><span>听听老大是什么意思吧，先别急。</span></p>
      <p class="fontBlue">「最佳选择」</p>
      <p>看来得先引导一下，让大家知道团队合作会给自己带来什么利益。</p>
      <div class="bg-lightBlue"><p class="excellentDemonstrationTitle"> 点 评</p>
        <p>在大家不明白原因、不清楚做法的时候，引导大家思考和激发想法，比起直接告诉他们原因和方法，会更有助于他们的成长，这也是你作为领导所必须给团队的支持。</p></div>
    </div>
    <div class="sectionSlide"  data-target="sectionBox8" #sectionSlide8 (click)="slideBestPathBox(sectionSlide8)">
      <div class="sectionIcon opacity100">剧情2</div>
    <p class="sectionSlideTriangle"></p>
    <p class="sectionSlideTxt">展开</p></div>


  <div class="sectionBox sectionBox9 hidden">
    <div class="sectionIcon">剧情3</div>
    <p><span class="fontBlue">我</span><span>大家现在都只专注做自己的事，不愿意合作。想想看团队如果高效合作的话，会给你们自己带来什么好处呢？</span></p>
    <p><span>王立娜</span><span>没想过，做好自己的事才是最重要的吧？</span></p>
    <p><span class="fontBlue">我</span><span>每个人都有自己最关心的事，如果团队中的所有人都知道他看重什么的话，那他是不是会更容易实现自己的目标呢？但前提是团队的高效合作，所以现在知道为什么让你们分享自己的期望了吧？</span>
    </p>
    <p><span>方科科</span><span>老大说得好像有点道理，那我先说，需要老大你提供一些资源哦。</span></p>
    <p><span>秦飞</span><span>好吧，原来高效合作还有这样的好处啊。</span></p>
    <p><span>季宁</span><span>我想得到大家的认可…</span></p>
    <p><span>旁白</span><span>之后大家纷纷列出了自己期望得到的利益，那接下来你会怎么做呢？</span></p>
    <p class="fontBlue">「最佳选择」</p>
    <p>既然大家的期望都列好了，那我们就来讨论下该如何合作来帮助彼此实现目标吧。</p>
    <div class="bg-lightBlue"><p class="excellentDemonstrationTitle"> 点 评</p>
      <p>到此时，虽然大家已经明白了原因，但还不清楚具体的做法。所以你要做的是支持他们，引导大家说出自己想怎么做。</p></div>
  </div>
  <div class="sectionSlide"  data-target="sectionBox9" #sectionSlide9 (click)="slideBestPathBox(sectionSlide9)">
      <div class="sectionIcon opacity100">剧情3</div>
  <p class="sectionSlideTriangle"></p>
  <p class="sectionSlideTxt">展开</p></div>


<div class="sectionBox sectionBox10 hidden">
  <div class="sectionIcon">剧情4</div>
  <p><span class="fontBlue">我</span><span>好了，既然大家的期望都列好了，那我们就来讨论下该如何合作来帮助彼此实现目标吧。</span></p>
  <p><span>季宁</span><span>我就希望在我做事做得比较好的时候能得到大家的肯定。</span></p>
  <p><span>方科科</span><span>我呢，嘴巴比较臭，就希望大家以后要是听着不舒服的时候和我直接反馈就好。我们也就可以把精力更多放在解决问题上了。</span></p>
  <p><span class="fontBlue">我</span><span>嗯，看来大家都知道今后该怎么做了，有些人也说到需要我的支持，我一定会全力协助的。</span></p>
  <p><span>旁白</span><span>经过一系列的讨论，最终大家都知道了在今后的团队合作中，如何帮助彼此实现目标。好啦，再想想还有什么需要做的呢？</span></p>
  <p class="fontBlue">「最佳选择」</p>
  <p>好了，看看后续怎么跟踪大家对合作的满意度吧。</p>
  <div class="bg-lightBlue"><p class="excellentDemonstrationTitle"> 点 评</p>
    <p>虽然团队成员都已经知道以后该怎么做了，但如果没有衡量方法，那结果就很难量化。所以最终还需要制定一套衡量和复核进展的标准。</p></div>
</div>
<div class="sectionSlide"  data-target="sectionBox10" #sectionSlide10 (click)="slideBestPathBox(sectionSlide10)">
      <div class="sectionIcon opacity100">剧情4</div>
<p class="sectionSlideTriangle"></p>
<p class="sectionSlideTxt">展开</p></div>

<div class="sectionBox sectionBox11 hidden">
  <div class="sectionIcon">剧情5</div>
  <p><span class="fontBlue">我</span><span>好，接下来我们来讨论下用什么频率，用什么样的办法来衡量大家对合作的满意度吧。</span></p>
  <p><span>方科科</span><span>老大思路真清晰啊，马上就想着怎么落地了。</span></p>
  <p><span>季宁</span><span>老大真的好为我们着想啊！</span></p>
  <p><span>秦飞</span><span>我觉得一周开一次会，让大家交流下自己的满意度就好啦。</span></p>
  <p><span>旁白</span><span>经过讨论，最终敲定了用周会报告满意度的方法来考核。好了，会议到此，方案在手，大家也认识到了合作的重要性。</span></p>
  <p class="fontBlue">「最佳选择」</p>
  <p>最后和大家确认下后续各自的行动吧。</p>
  <div class="bg-lightBlue"><p class="excellentDemonstrationTitle"> 点 评</p>
    <p>每次会议有了决议，如果没有后续的行动计划，怎么保证大家都会执行呢？所以“议而有决“后，一定要明确后续步骤和追踪方法来保证“决而有行，行而有果”。</p></div>
</div>
<div class="sectionSlide"  data-target="sectionBox11" #sectionSlide11 (click)="slideBestPathBox(sectionSlide11)">
      <div class="sectionIcon opacity100">剧情5</div>
<p class="sectionSlideTriangle"></p>
<p class="sectionSlideTxt">展开</p></div>


<div class="sectionBox sectionBox12 hidden">
  <div class="sectionIcon">结局</div>
  <p><span class="fontBlue">我</span><span>好啦，最后我们来总结一下后续的追踪计划吧。比如评估满意度的日期，还有谁来设定具体的衡量方法，最后会议谁来组织吧。</span></p>
  <p><span>王立娜</span><span>我来设定衡量方法吧，这个我喜欢做~</span></p>
  <p><span>秦飞</span><span>那我来组织会议吧，毕竟这个提案是我提出的。</span></p>
  <p><span class="fontBlue">我</span><span>好的，希望通过这次会议，以后大家能多去寻求其他人的帮助，也互相多给反馈，积极合作哈！散会！</span></p>
</div>
<div class="sectionSlide"  data-target="sectionBox12" #sectionSlide12 (click)="slideBestPathBox(sectionSlide12)">
      <div class="sectionIcon opacity100">结局</div>
<p class="sectionSlideTriangle"></p>
<p class="sectionSlideTxt">展开</p></div>

<p class="sectionTitle">结果因素</p>

<div class="sectionBox sectionBox13 hidden">
  <div class="sectionIcon">剧情1</div>
  <p><span class="fontBlue">我</span><span>最近我发现了一个问题，就是有些伙伴做事有时候会搞不清重点。导致要么忙于救火，要么就在一些无关紧要的事上花了很多时间。</span></p>
  <p><span>方科科</span><span>有么？反正我们现在做的事本来就很杂啊。</span></p>
  <p><span>王立娜</span><span>有啊，我也感觉到了，事情做了很多，但也没产生很好的结果啊。</span></p>
  <p><span>季宁</span><span>【内心OS：难道我有什么地方做错了？】</span></p>
  <p><span>秦飞</span><span>老大你应该是有办法了吧，告诉我们呗。</span></p>
  <p><span>旁白</span><span>开始你的表演吧~</span></p>
  <p class="fontBlue">「最佳选择」</p>
  <p>祭出“团队任务聚焦表”，让每人列出他觉得重要的事项，再讨论都支持了什么团队目标。</p>
  <div class="bg-lightBlue"><p class="excellentDemonstrationTitle"> 点 评</p>
    <p>在团队成员做事没有重点的时候，他很可能不明白自己做的事和团队目标之间有什么关系，所以让他明白自己做的事能支持什么样的团队目标，会让他做事更聚焦、有重点。</p></div>
</div>
<div class="sectionSlide"  data-target="sectionBox13" #sectionSlide13 (click)="slideBestPathBox(sectionSlide13)">
      <div class="sectionIcon opacity100">剧情1</div>
<p class="sectionSlideTriangle"></p>
<p class="sectionSlideTxt">展开</p></div>


<div class="sectionBox sectionBox14 hidden">
  <div class="sectionIcon">剧情2</div>
  <p><span class="fontBlue">我</span><span>嗯，我这里有个办法来看看大家现在做的事到底是不是重要的，这是“团队任务聚焦表”。大家把自己认为重要的事项写到这个表上，然后我们一起来讨论下，这些事项都支持了什么团队目标。</span>
  </p>
  <p><span>王立娜</span><span>好的，那我先写吧。</span></p>
  <p><span>方科科</span><span>【内心OS：这个办法真的有用么？我先看看大家写了什么吧。】</span></p>
  <p><span>季宁</span><span>我接着立娜后面写吧。</span></p>
  <p><span>秦飞</span><span>大家写得很全啦，我没什么可以补充的了</span></p>
  <p class="fontBlue">「最佳选择」</p>
  <p>好了，根据表上所列的一起理出目前团队最重要的几个优先事项吧。</p>
  <div class="bg-lightBlue"><p class="excellentDemonstrationTitle"> 点 评</p>
    <p>让大家一起参与讨论出最重要的优先事项，这样团队成员会更加认可，因为是大家一起讨论出的结果，之后的执行也会使命必达。</p></div>
</div>
<div class="sectionSlide"  data-target="sectionBox14" #sectionSlide14 (click)="slideBestPathBox(sectionSlide14)">
      <div class="sectionIcon opacity100">剧情2</div>
<p class="sectionSlideTriangle"></p>
<p class="sectionSlideTxt">展开</p></div>


<div class="sectionBox sectionBox15 hidden">
  <div class="sectionIcon">剧情3</div>
  <p><span class="fontBlue">我</span><span>现在我们来理一下，看看每条事项都支持了什么团队目标，然后选出最重要的几个优先事项。</span></p>
  <p><span>旁白</span><span>经过一个小时的讨论，最终定下来几个最优先的事项。</span></p>
  <p><span class="fontBlue">我</span><span>好了，现在大家应该明确自己该优先做哪些事了吧，不能支持到团队目标的事务可以放次要做，清楚了吧？</span></p>
  <p><span>方科科</span><span>（内心OS）这样讨论下来，原来我之前忙于救火是因为这样啊。</span></p>
  <p><span>季宁</span><span>嗯，老大说得是，我以后会更加聚焦让旅客满意这个目标上。</span></p>
  <p class="fontBlue">「最佳选择」</p>
  <p>定个方法让大家定期回顾进展，我也能指导下。</p>
  <div class="bg-lightBlue"><p class="excellentDemonstrationTitle"> 点 评</p>
    <p>对于结果因素来说，定期复核团队的成果和进展，并给到大家正面反馈和改进型反馈显得尤为重要，因为这样你才能保证整个团队都向着正确的结果稳步迈进。</p></div>
</div>
<div class="sectionSlide"  data-target="sectionBox15" #sectionSlide15 (click)="slideBestPathBox(sectionSlide15)">
      <div class="sectionIcon opacity100">剧情3</div>
<p class="sectionSlideTriangle"></p>
<p class="sectionSlideTxt">展开</p></div>

<div class="sectionBox sectionBox16 hidden">
  <div class="sectionIcon">结局</div>
  <p><span class="fontBlue">我</span><span>为了保证大家持续在这些优先事项上有所进展，我们每天开一个会吧，时间不长，大概5分钟吧。每人回顾下自己当天工作的进展，如果我发现问题，也会及时给大家一些反馈，保证我们团队重要目标的完成。</span>
  </p>
  <p><span>王立娜</span><span>每天只要5分钟，回顾下进展挺好的呀。</span></p>
  <p><span>季宁</span><span>请老大多多指导。</span></p>
  <p><span>方科科</span><span>【内心OS：看来这样的话，我之前老是救火的问题就能解决了。】</span></p>
  <p><span>秦飞</span><span>老大，我觉得大家应该对于接下去的工作重点很清楚了。</span></p>
  <p><span class="fontBlue">我</span><span>好的，我们的工作就是要保证都聚焦在实现结果，这样才有意义，大家努力吧！</span></p>
</div>
<div class="sectionSlide"  data-target="sectionBox16" #sectionSlide16 (click)="slideBestPathBox(sectionSlide16)">
      <div class="sectionIcon opacity100">结局</div>
<p class="sectionSlideTriangle"></p>
<p class="sectionSlideTxt">展开</p></div>

<p class="sectionTitle">沟通因素</p>

<div class="sectionBox sectionBox17 hidden">
  <div class="sectionIcon">剧情1</div>
  <p><span>王立娜</span><span>方科科，你能听我把话说完么？你这样对我很不尊重！</span></p>
  <p><span>方科科</span><span>你的提案完全不可行好么？我不打断让你继续说，就是浪费大家的时间。</span></p>
  <p><span>秦飞</span><span>好啦好啦，大家各退一步，想想自己的问题呗~</span></p>
  <p><span>方科科</span><span>王立娜，你以为你就没问题啊！</span></p>
  <p><span>秦飞</span><span>呃……</span></p>
  <p><span>季宁</span><span>（内心OS）好吧，我还是不说话了…</span></p>
  <p><span>秦飞</span><span>啊，老大来了！</span></p>
  <p><span>旁白</span><span>又是一个好熟悉的场景，你会怎么做呢？</span></p>
  <p class="fontBlue">「最佳选择」</p>
  <p>唉？我还是先问问到底是什么情况吧。</p>
  <div class="bg-lightBlue"><p class="excellentDemonstrationTitle"> 点 评</p>
    <p>当下属发生争执时，一定要先问情况，让当事人先发表自己的观点，避免根据过往的印象和经验来主观臆断。</p></div>
</div>
<div class="sectionSlide"  data-target="sectionBox17" #sectionSlide17 (click)="slideBestPathBox(sectionSlide17)">
      <div class="sectionIcon opacity100">剧情1</div>
<p class="sectionSlideTriangle"></p>
<p class="sectionSlideTxt">展开</p></div>

<div class="sectionBox sectionBox18 hidden">
  <div class="sectionIcon">剧情2</div>
  <p><span class="fontBlue">我</span><span>怎么了，发生了什么事？</span></p>
  <p><span>方科科</span><span>52舱食物配给和垃圾回收处理出了问题，我在和王立娜沟通解决办法，但是她的提案完全不可行，所以我就打断她了，就这么回事，小题大做。</span></p>
  <p><span>王立娜</span><span>你知道这样很不尊重人么？先不说我，季宁发言你就不知道打断了多少次。对吧，季宁？</span></p>
  <p><span>季宁</span><span>啊...这个...</span></p>
  <p><span>秦飞</span><span>老大，我觉得我们团队在沟通上真的很有问题啊……</span></p>
  <p class="fontBlue">「最佳选择」</p>
  <p>先让大家冷静下吧，都回去想想在沟通上需要哪些基本规则吧。</p>
  <div class="bg-lightBlue"><p class="excellentDemonstrationTitle"> 点 评</p>
    <p>沟通出了问题，有很多原因，可能是彼此不够尊重，可能是过往的说话方式差异太大，也可能是彼此不够信任。这时就需要大家一起讨论制定出一套规范来约束行为，不然长期以往肯定会损害到整个团队的合作和信任。</p></div>
</div>
<div class="sectionSlide"  data-target="sectionBox18" #sectionSlide18 (click)="slideBestPathBox(sectionSlide18)">
      <div class="sectionIcon opacity100">剧情2</div>
<p class="sectionSlideTriangle"></p>
<p class="sectionSlideTxt">展开</p></div>

<div class="sectionBox sectionBox19 hidden">
  <div class="sectionIcon">剧情3</div>
  <p><span class="fontBlue">我</span><span>好了，我观察下来，发现大家的沟通的确存在问题。你们都先回去冷静下。然后每人都思考一下我们团队在“聆听、参与、表达清晰、鼓励创意、开放性、尊重”这6个沟通维度上，你们自己认为比较需要的规则，明天带来讨论，我们一起来制定团队沟通的基本规则。</span>
  </p>
  <p><span>秦飞</span><span>（内心OS）真是老大一出手，便知有没有啊…</span></p>
  <p><span>方,王,季</span><span>好的，老大！</span></p>
  <p><span>旁白</span><span>第二天，会议室。</span></p>
  <p class="fontBlue">「最佳选择」</p>
  <p>让大家写出想到的吧，要引导他们互相理解对方为什么会想到这些基本规则。</p>
  <div class="bg-lightBlue"><p class="excellentDemonstrationTitle"> 点 评</p>
    <p>在团队成员讨论彼此的想法时，很可能因为彼此的认知不同，产生很多误会。这里就需要你给予适当的引导和程序建议，保证大家的讨论朝着好的方向迈进。</p></div>
</div>
<div class="sectionSlide"  data-target="sectionBox19" #sectionSlide19 (click)="slideBestPathBox(sectionSlide19)">
      <div class="sectionIcon opacity100">剧情3</div>
<p class="sectionSlideTriangle"></p>
<p class="sectionSlideTxt">展开</p></div>

<div class="sectionBox sectionBox20 hidden">
  <div class="sectionIcon">剧情4</div>
  <p><span class="fontBlue">我</span><span>大家昨天都想好了吧，来，请到电子屏上写出自己在这6个维度上想到的基本规则。先说明下，不许评价别人写的东西，但是我鼓励大家对别人写的内容进行提问，互相了解每个人是怎么想的。</span>
  </p>
  <p><span>秦飞</span><span>【内心OS：老大真有两把刷子。】</span></p>
  <p><span>方科科</span><span>提问啊？我最喜欢了！</span></p>
  <p><span>旁白</span><span>经过热烈的讨论，大家对6个维度的所有基本规则都非常清楚了。</span></p>
  <p class="fontBlue">「最佳选择」</p>
  <p>现在的基本规则不少是可以合并的，一起筛选下吧，这样接受起来也比较容易。</p>
  <div class="bg-lightBlue"><p class="excellentDemonstrationTitle"> 点 评</p>
    <p>在大家的意见很多的时候，你可以通过求同存异共识找到观点中的共识，而不是简单列举。再次筛选和讨论的过程也会让大家对彼此的观点了解得更深刻，这对促成共识也很有帮助。</p></div>
</div>
<div class="sectionSlide"  data-target="sectionBox20" #sectionSlide20 (click)="slideBestPathBox(sectionSlide20)">
      <div class="sectionIcon opacity100">剧情4</div>
<p class="sectionSlideTriangle"></p>
<p class="sectionSlideTxt">展开</p></div>

<div class="sectionBox sectionBox21 hidden">
  <div class="sectionIcon">剧情5</div>
  <p><span
    class="fontBlue">我</span><span>我们来一起看一下，哪些规则是比较类似的，把它们合并起来。然后再看看哪些规则对于我们团队的成功并不重要，就删掉它。都踊跃发言啊，开始吧。</span></p>
  <p><span>方科科</span><span>“展示你已经听到并理解别人的话”和“复述别人的话”很类似嘛，合并吧。</span></p>
  <p><span>王立娜</span><span>这条我觉得不重要，因为……</span></p>
  <p><span>季宁</span><span>我觉得这两条也好像。</span></p>
  <p><span>旁白</span><span>因为大家都已经非常了解所有列示的规则，所以很快就整理了出来。</span></p>
  <p><span class="fontBlue">我</span><span>好了，这是大家经过讨论后剩下的条目，我们就把它们作为团队沟通的基本规则吧，大家觉得可以吗？</span></p>
  <p><span>秦飞</span><span>没问题，这是大家一起商定的。</span></p>
  <p class="fontBlue">「最佳选择」</p>
  <p>好了，最后和大家一起确认下后续要采取什么行动来遵循这些基本规则吧。</p>
  <div class="bg-lightBlue"><p class="excellentDemonstrationTitle"> 点 评</p>
    <p>“凡是决议，必有跟踪”，在会议的最后，需要制定具体的行动计划才能让大家在会后言出必行，行之必果。</p></div>
</div>
<div class="sectionSlide"  data-target="sectionBox21" #sectionSlide21 (click)="slideBestPathBox(sectionSlide21)">
      <div class="sectionIcon opacity100">剧情5</div>
<p class="sectionSlideTriangle"></p>
<p class="sectionSlideTxt">展开</p></div>

<div class="sectionBox sectionBox22 hidden">
  <div class="sectionIcon">结局</div>
  <p><span class="fontBlue">我</span><span>我们已经有了团队沟通的规则，那针对每条规则，接下来该做什么来确保大家都遵循呢？</span></p>
  <p><span>秦飞</span><span>这样，我们每周开一次会议，然后大家按照这些规则，给每个人来打分，看看每个人做得如何。</span></p>
  <p><span>季宁</span><span>如果哪个规则没做好，就给对方反馈哪里没做好。</span></p>
  <p><span>王立娜</span><span>那我来设计分数规则吧。</span></p>
  <p><span>方科科</span><span>那我就负责每次会议计分，最后公布出来，让大家互相督促执行吧。</span></p>
  <p><span class="fontBlue">我</span><span>嗯，会后再请季宁把沟通基本规则也发布到控制室的主银幕上。对于行为不当，或者反复破坏规则的伙伴，也会有惩罚哦。</span></p>
  <p><span>季宁</span><span>好的。</span></p>
  <p><span class="fontBlue">我</span><span>大家没问题了吧，那就遵照执行了，解散！</span></p>
</div>
<div class="sectionSlide"  data-target="sectionBox22" #sectionSlide22 (click)="slideBestPathBox(sectionSlide22)">
      <div class="sectionIcon opacity100">结局</div>
<p class="sectionSlideTriangle"></p>
<p class="sectionSlideTxt">展开</p></div>

<p class="sectionTitle">信任因素</p>

<div class="sectionBox sectionBox23 hidden">
  <div class="sectionIcon">剧情1</div>
  <p><span class="fontBlue">我</span><span>好了，刚才是我对这次空间站对接补给计划的建议，你们还有什么想法？</span></p>
  <p><span>方科科</span><span>我没意见。【内心OS：这啥破建议。】</span></p>
  <p><span>秦飞</span><span>老大你的意见很好啊。【内心OS：我不能说不好，免得老板不高兴。】</span></p>
  <p><span>王立娜</span><span>老大你说得都对。</span></p>
  <p><span>季宁</span><span>【内心OS：我还是不说了，反正我说了他也不会采纳的。】</span></p>
  <p><span>旁白</span><span>好像气氛有些尴尬，大家都不愿意说心里话，周明需要你的帮助~</span></p>
  <p class="fontBlue">「最佳选择」</p>
  <p>唉，看来我不被信任啊，说一下自己的感受吧，问问他们为啥不提建议或者异议吧。</p>
  <div class="bg-lightBlue"><p class="excellentDemonstrationTitle"> 点 评</p>
    <p>当团队成员没有给出自己预期的反应时，可以发表一些自己的感受，在了解了你的真实感受以后，大家可能也更愿意参与进来说出自己的想法。</p></div>
</div>
<div class="sectionSlide"  data-target="sectionBox23" #sectionSlide23 (click)="slideBestPathBox(sectionSlide23)">
      <div class="sectionIcon opacity100">剧情1</div>
<p class="sectionSlideTriangle"></p>
<p class="sectionSlideTxt">展开</p></div>


<div class="sectionBox sectionBox24 hidden">
  <div class="sectionIcon">剧情2</div>
  <p><span class="fontBlue">我</span><span>每次我问大家建议的时候，都没有人提出异议，或者给出建议，这让我感觉到自己不被大家信任。我真心想问一下是我做了什么让你们感到不能信任？我不想听一些面上的话，要听各位的心里话。</span>
  </p>
  <p><span>王立娜</span><span>我先来吧老大，以前我们是提意见的。但每次提了你都好像不太高兴，也不采纳，后来大家就不愿说了。</span></p>
  <p><span>秦飞</span><span>老大你就是平时太忙了，和我交流得太少了，除了布置任务，基本不理我的哦。</span></p>
  <p><span>季宁</span><span>老大，可能我经验不是很足吧，你对我这边的事管得特别多。我感觉你可能是怀疑我的能力，所以也不敢多说话。</span></p>
  <p class="fontBlue">「最佳选择」</p>
  <p>真没想到有这么多原因，得再让大家提出对我的要求，看看我以后该怎么做来重建信任。</p>
  <div class="bg-lightBlue"><p class="excellentDemonstrationTitle"> 点 评</p>
    <p>当你想和大家讨论如何改进问题时，首先做到以身作则，从自身检视开始，然后再去一起讨论如何改进，这样大家会更容易接受你的建议，讨论也会更积极。</p></div>
</div>
<div class="sectionSlide"  data-target="sectionBox24" #sectionSlide24 (click)="slideBestPathBox(sectionSlide24)">
      <div class="sectionIcon opacity100">剧情2</div>
<p class="sectionSlideTriangle"></p>
<p class="sectionSlideTxt">展开</p></div>

<div class="sectionBox sectionBox25 hidden">
  <div class="sectionIcon">剧情3</div>
  <p><span
    class="fontBlue">我</span><span>很高兴听到大家的心里话。为了加强以后我们团队成员之间的信任，我想做个表率，让大家列出对我的要求，看看我该做到哪些才能获得大家的信任。</span></p>
  <p><span>秦飞</span><span>【内心OS：老大也是蛮拼的，好低的姿态。】</span></p>
  <p><span>方科科</span><span>那我不客气了哈。</span></p>
  <p><span>王立娜</span><span>老大蛮有诚意的嘛。</span></p>
  <p><span>季宁</span><span>好的，老大！</span></p>
  <p><span>旁白</span><span>大家纷纷写下了自己的期望，接下来，你会做些什么来加强团队成员之间的信任呢？</span></p>
  <p class="fontBlue">「最佳选择」</p>
  <p>得让大家通过一个活动来增进互信感，比如先让每个人分享一些自己的信息吧。</p>
  <div class="bg-lightBlue"><p class="excellentDemonstrationTitle"> 点 评</p>
    <p>有时大家需要彼此知道对方更多的信息，才能更好地建立信任，所以让他们实际体验一下会更有效果哦。</p></div>
</div>
<div class="sectionSlide"  data-target="sectionBox25" #sectionSlide25 (click)="slideBestPathBox(sectionSlide25)">
      <div class="sectionIcon opacity100">剧情3</div>
<p class="sectionSlideTriangle"></p>
<p class="sectionSlideTxt">展开</p></div>

<div class="sectionBox sectionBox26 hidden">
  <div class="sectionIcon">剧情4</div>
  <p><span class="fontBlue">我</span><span>好啦，我之后会严格执行大家对我的期望，在周会上也请大家给我反馈，看看我做得如何。现在我想做个小活动，叫“认识彼此”。请每人分享一些自己的信息，最好是有“自己的爱好，喜欢和不喜欢的工作方式，雷区，容易带给别人的误解，常会对他人做的假设”等等，然后大家可以互相提问。因为只有更加了解彼此，才能增进互相的信任感哦。我先来做个示范哈（示范中……）。</span>
  </p>
  <p><span>秦飞</span><span>【内心OS：老大这步棋厉害~】</span></p>
  <p><span>季宁</span><span>【内心OS：老大真是帮了我大忙了，我就是太害羞不敢和大家聊自己……】</span></p>
  <p><span>王立娜</span><span>好吧，我在这个移民项目中时间最长，我先说吧。</span></p>
  <p><span>旁白</span><span>接下来，每个人都兴奋地分享了自己的信息。</span></p>
  <p class="fontBlue">「最佳选择」</p>
  <p>引导他们想想在了解这些信息后，会怎么帮助到建立信任，这样他们以后就会更积极。</p>
  <div class="bg-lightBlue"><p class="excellentDemonstrationTitle"> 点 评</p>
    <p>有了信息，但怎么用？这就需要你给予团队成员引导了。协助他人激发想法也是领导者的重要职责。</p></div>
</div>
<div class="sectionSlide"  data-target="sectionBox26" #sectionSlide26 (click)="slideBestPathBox(sectionSlide26)">
      <div class="sectionIcon opacity100">剧情4</div>
<p class="sectionSlideTriangle"></p>
<p class="sectionSlideTxt">展开</p></div>

<div class="sectionBox sectionBox27 hidden">
  <div class="sectionIcon">结局</div>
  <p><span class="fontBlue">我</span><span>在刚才大家的相互提问中，我发现了一个有趣的现象，就是互相了解背景后，可以帮助大家避免臆测对方的想法。因为每个人看事的角度都是不一样的。所以请大家回想一下，在刚才的提问中，你得到的信息能怎么样帮助自己和他人建立信任呢？请列出来分享给大家哦。</span>
  </p>
  <p><span>方科科</span><span>哦，比如理解彼此的爱好，能让彼此有连接啊。</span></p>
  <p><span>季宁</span><span>这样我就能了解其他人行为的原因啦，就不会造成误会了。</span></p>
  <p><span>王立娜</span><span>可不是么，怪不得我老是惹方科科不开心啊。</span></p>
  <p><span>旁白</span><span>接下来，大家很积极地分享了自己的感受和观点。</span></p>
  <p><span class="fontBlue">我</span><span>非常感谢大家积极的参与，既然大家都意识到了了解彼此对于互相信任的重要性，建议大家以后继续彼此分享事实、意见和感受哦。还有我会经常组织聚餐，让大家多多交流工作以外的东西，敬请期待！</span>
  </p>
</div>
<div class="sectionSlide"  data-target="sectionBox27" #sectionSlide27 (click)="slideBestPathBox(sectionSlide27)">
      <div class="sectionIcon opacity100">结局</div>
<p class="sectionSlideTriangle"></p>
<p class="sectionSlideTxt">展开</p></div>

    </div>

    <div id="analysisBox" [@analysisBoxAnimation]="analysisBoxShow ? 'showAnalysisBox' : 'hideAnalysisBox'">
      <div id="analysisHead">
        <div class="fontSize18 lineHeight27" id="analysisHeadOne">{{currentName}}</div>
        <div class="fontSize14 lineHeight21" id="analysisHeadTwo">
          {{currentDescription}}
        </div>
        <div [@starAnimation]="starShow ? 'showStar' : 'hideStar'">
          <img src="{{assetsRoute}}/picture/casepracticeteam/star_report.png" alt="" class="starReport starReport1" *ngIf="currentTotal>=5">
          <img src="{{assetsRoute}}/picture/casepracticeteam/star_report.png" alt="" class="starReport starReport2" *ngIf="currentTotal>=4">
          <img src="{{assetsRoute}}/picture/casepracticeteam/star_report.png" alt="" class="starReport starReport3" *ngIf="currentTotal>=3">
          <img src="{{assetsRoute}}/picture/casepracticeteam/star_report.png" alt="" class="starReport starReport4" *ngIf="currentTotal>=2">
          <img src="{{assetsRoute}}/picture/casepracticeteam/star_report.png" alt="" class="starReport starReport5" *ngIf="currentTotal>=1">
        </div>
      </div>
      <div id="analysisContent" class="fontSize16 lineHeight24" [innerHtml]="currentAnalysis">

      </div>
      <div id="closeBtn3" (click)="analysisBoxOut()"></div>
    </div>

    <div id="shade"></div>
    <div id="tourReviewShade" (click)="tourReviewBoxOut()"></div>
    <div id="analysisShade" (click)="analysisBoxOut()"></div>

    <div id="closeBtn2" (click)="bestPathOut()"></div>

    <div id="btnWrap" [@btnWrapAnimation]="btnWrapShow ? 'showButtonWrap': 'hideButtonWrap'">
      <div id="btnLeft" class="fontSize18" (click)="bestPathIn()">
        优秀示范
      </div>
      <div id="btnMiddle" class="fontSize18" (click)="redo()">
        重做一次
      </div>
      <div id="btnRight" class="fontSize18" (click)="goToList()">
        返回列表
      </div>
      <img src="{{assetsRoute}}/picture/casepracticeteam/btn_line.png" alt="" id="btnLine1">
      <img src="{{assetsRoute}}/picture/casepracticeteam/btn_line.png" alt="" id="btnLine2">

    </div>
</div>
  <!--新增等级说明-->
  <app-report-level  [reportKAData] = "reportKAData"></app-report-level>
</div>





// WEBPACK FOOTER //
// ./src/app/case-practice-team-report/case-practice-team-report.component.html